module.exports = __webpack_public_path__ + "img/software-development.dc5054b6.svg";